import Head from 'next/head';
import Link from 'next/link';
import { ArrowLeft, AlertTriangle } from 'lucide-react';
import type { LegalDoc } from '../content/legal';
import { LEGAL_LINKS } from '../content/legal';

interface LegalPageProps {
  doc: LegalDoc;
}

export function LegalPage({ doc }: LegalPageProps) {
  return (
    <div style={{ maxWidth: 760, margin: '0 auto', padding: '32px 20px 64px', color: 'var(--text-main)', lineHeight: 1.6 }}>
      <Head><title>{doc.title} – MAX Магазин</title></Head>

      <Link href="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: 'var(--text-muted)', fontSize: 14, textDecoration: 'none' }}>
        <ArrowLeft size={16} /> На главную
      </Link>

      <h1 style={{ fontSize: 28, fontWeight: 800, margin: '16px 0 4px' }}>{doc.title}</h1>
      <div style={{ color: 'var(--text-subtle)', fontSize: 13, marginBottom: 24 }}>Обновлено: {doc.updated}</div>

      {doc.lawyerNote && (
        <div style={{
          display: 'flex', alignItems: 'flex-start', gap: 8,
          background: 'var(--warning-bg)', border: '1px solid var(--warning-border)', borderRadius: 8,
          padding: '12px 14px', fontSize: 14, color: 'var(--warning-text)', marginBottom: 24,
        }}>
          <AlertTriangle size={16} style={{ flexShrink: 0, marginTop: 2 }} />
          <span>
            Шаблонный текст. До боевого использования требует проверки практикующего юриста и
            заполнения реквизитов.
          </span>
        </div>
      )}

      {doc.intro && <p style={{ marginBottom: 24 }}>{doc.intro}</p>}

      {doc.sections.map((s) => (
        <section key={s.h} style={{ marginBottom: 20 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>{s.h}</h2>
          {s.body.map((p, i) => (
            <p key={i} style={{ marginBottom: 8 }}>{p}</p>
          ))}
        </section>
      ))}

      <nav style={{ marginTop: 40, paddingTop: 20, borderTop: '1px solid #e5e7eb', display: 'flex', flexWrap: 'wrap', gap: 16 }}>
        {LEGAL_LINKS.map((l) => (
          <Link key={l.slug} href={`/legal/${l.slug}`} style={{ color: '#6b7280', fontSize: 14, textDecoration: 'none' }}>
            {l.label}
          </Link>
        ))}
      </nav>
    </div>
  );
}
